/* eslint-disable no-warning-comments */
window.filters = (function() {
  'use strict';

  function adjustFilters() {
    let filterContainers = document.querySelectorAll('.filter'),
        allItems = document.querySelectorAll('[data-filter-tags]'),
        activeTags = [];
    const liveRegion = document.querySelector('.aria-status');

    filterContainers.forEach(function(filter) {
      let selectedActions = filter.querySelectorAll('.js-filter__action.is-selected');

      selectedActions.forEach(function(action) {
        let filterTags = action.getAttribute('data-tags').split(';');

        filterTags.forEach(function(tag) {
          if (!activeTags.includes(tag)) {
            activeTags.push(tag);
          }
        });
      });
    });

    allItems.forEach(function(tagged) {
      let allTags = tagged.getAttribute('data-filter-tags').split(';');

      tagged.style.display = "none";

      let isVisible = activeTags.every(function(tag) {
        return allTags.includes(tag);
      });

      if (isVisible) {
        tagged.style.display = "";
      }
    });

    window.dispatchEvent(new CustomEvent('filterschanged', {detail: {filters: activeTags}}));

    // Update the live region with the current filter state
    if (liveRegion) {
      liveRegion.textContent = ''; // reset for continues updates after new filter action.
      setTimeout(() => {
        liveRegion.textContent = `Er zijn nieuwe resultaten beschikbaar.`;
      }, 100);
    }
    
  }

  function filterClicked(event, action, filter) {
    let filterActions = Array.from(filter.querySelectorAll('.js-filter__action')),
        newMeetId = action.getAttribute('data-meetid').split('-selected')[0],
        sameAction = action.classList.contains('is-selected');

    event.preventDefault();
    event.stopPropagation();

    // Clear all items within the same filter
    filterActions.forEach(function(fa) {
      fa.classList.remove('is-selected');
      fa.setAttribute('aria-selected', 'false');
      fa.setAttribute('data-meetid', fa.getAttribute('data-meetid').replace('-selected', ''));
    });

    // Select the clicked action if it was not already selected
    if (!sameAction) {
      action.classList.add('is-selected');
      action.setAttribute('aria-selected', 'true');
      action.setAttribute('data-meetid', newMeetId + '-selected');
    }

    adjustFilters();
  }

  return {
    init: function() {
      let filterContainers = document.querySelectorAll('.filter');

      filterContainers.forEach(function(filter) {
        let filterActions = filter.querySelectorAll('.js-filter__action');

        filterActions.forEach(function(action) {
          action.addEventListener('click', event => filterClicked(event, action, filter));
        });
      });

      adjustFilters();
    },
    refilter: function() {
      adjustFilters();
    }
  };
})();

filters.init();
